import React from 'react'
import AccountContent from '~components/pages/account/AccountContent'

const AccountPage: React.FC = () => {
  return (
    <>
      <AccountContent />
    </>
  )
}

export default AccountPage
